import React, { useState, useEffect } from "react"
import DataGrid from "../DataGrid/DataGrid"
import dayjs from "dayjs"

const TAB_LABELS = {
    RECETTE: "Recette",
    ETAPES_PROD: "Étapes de prod",
    DETAILS: "Détails",
    GENERAL: "Général",
    REMARQUES: "Général"
}

// Entries saved before the fields were traced carry no "fields" key
const getFieldsLabel = (fields) => {
    if (!fields) return "Non renseigné"
    if (!fields.length) return "Aucun changement détecté"
    return fields.join(", ")
}

const columnHeaders = [
    {
        key: "date",
        label: "Date",
        filterable: false,
        width: "calc((100% - 112px) * 0.20)"
    },
    {
        key: "user",
        label: "Utilisateur",
        filterable: false,
        width: "calc((100% - 112px) * 0.20)"
    },
    {
        key: "tab",
        label: "Onglet",
        filterable: false,
        width: "calc((100% - 112px) * 0.15)"
    },
    {
        key: "fields",
        label: "Champs modifiés",
        filterable: false,
        width: "calc((100% - 112px) * 0.45)"
    }
]

const RecipeSaveHistoryTable = ({ saveHistory }) => {
    const [data, setData] = useState([])

    useEffect(() => {
        const entries = saveHistory ? [...saveHistory].reverse() : []
        setData(entries.map(entry => ({
            date: dayjs(entry.date).format("DD/MM/YYYY HH:mm:ss"),
            user: entry.user && entry.user.username
                ? entry.user.username.split("@")[0]
                : "Inconnu",
            tab: TAB_LABELS[entry.tab] || entry.tab,
            fields: getFieldsLabel(entry.fields)
        })))
    }, [saveHistory])

    if (!saveHistory || !saveHistory.length) {
        return <p style={{ padding: 16, color: "#666" }}>Aucun historique disponible.</p>
    }

    return (
        <DataGrid
            withFilters={false}
            title="Historique des sauvegardes"
            data={data}
            columns={columnHeaders}
        />
    )
}

export default RecipeSaveHistoryTable
